import { render } from "./TextSignature.vue.ts?vue&type=template&id=645249c2&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TextSignature.vue?vue&type=template&id=645249c2&scoped=true&ts=true"
import script from "./TextSignature.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TextSignature.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextSignature.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TextSignature.vue?vue&type=script&setup=true&lang=ts"

import "./TextSignature.vue.scss?vue&type=style&index=0&id=645249c2&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TextSignature.vue?vue&type=style&index=0&id=645249c2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645249c2"],['__file',"src/apps/merchant3/shared-components/common/TextSignature.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "645249c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('645249c2', __exports__)) {
    api.reload('645249c2', __exports__)
  }
  
  module.hot.accept("./TextSignature.vue.ts?vue&type=template&id=645249c2&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TextSignature.vue?vue&type=template&id=645249c2&scoped=true&ts=true", () => {
    api.rerender('645249c2', render)
  })

}


export default __exports__